import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, InputGroupAddon, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class ShopFilterSearchTextbox extends Component {
  static propTypes = {
    setSearchValue: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    windowWidth: PropTypes.number.isRequired,
    cartItemCount: PropTypes.number
  }

  constructor(props) {
    super(props);
  }

 render() {
    //const ExampleObject = ( <div></div> );

    return (
     <div style={{"width":"100%"}}>
        {this.props.windowWidth < 768 ?
          <ComponentContainer>
            <FilterImage src={require("../media/tinyFilter.png")} style={{marginRight: "15px"}} 
              onClick={this.props.toggleFilter}></FilterImage>
            <LocatorNavLink tag={Link} to="/Locator">
              <img src={require("../media/tinyLocations.png")}></img>
            </LocatorNavLink>


            <SearchInput placeholder={this.props.windowWidth < 576 ? "Search" : "Search Products"} 
                         value={this.props.searchValue} onChange={(e) => this.props.setSearchValue(e)} />

            <SearchInputGroupAddon addonType="append">
              <img src={require("../media/tinySearch.png")}></img>
            </SearchInputGroupAddon>


            <OffersNavLink tag={Link} to="/Offers">
              <img src={require("../media/tinyOffers.png")}></img>
            </OffersNavLink>
            <CartContainer className="snipcart-checkout snipcart-summary">
              <img src={require("../media/tinyCart.png")}></img>
              <span>{this.props.cartItemCount}</span>
            </CartContainer>
            
          </ComponentContainer>
          :
          ""
        }

        {this.props.windowWidth > 767 ?
          <ContainerDiv_Over767>
            <SearchInput placeholder="Search Products" value={this.props.searchValue} onChange={(e) => this.props.setSearchValue(e)} />
            <SearchInputGroupAddon addonType="append">
              <FilterImage src={require("../media/tinySearch.png")}></FilterImage>
            </SearchInputGroupAddon>
          </ContainerDiv_Over767>
          :
          ""
        }
      </div>


    );
  }
}

const FilterImage = styled.img`
  height: 30px;
  width: 30px;
  cursor: pointer;
`;

const SearchInputGroupAddon = styled(InputGroupAddon)`
  height: 35px;
  padding: 0;
  margin-left: -1px;
  background: white;
  border: 1px solid gray!important;
  border-left: 0!important;

  img {
    width: 30px!important;
    height: 25px!important;
    margin: 2.5px 2.5px 0 0;
  }
`;

const OffersNavLink = styled(NavLink)`
  height: 30px;
  width: 30px;
  padding: 0!important;
  margin: 0 15px 0 15px;
`;
const LocatorNavLink = styled(NavLink)`
  height: 30px;
  width: 30px;
  padding: 0!important;
  margin-right: 15px;

  img {

  }
`;

const ComponentContainer = styled(Container)` 
  display: flex;
  padding: 0!important;


`;

const CartContainer = styled.div`
  height: 30px;
  cursor: pointer;
  
  img {
    height: 30px;
    width: 30px;
    cursor: pointer;
  }

  span {
    position: absolute;
    margin: -2px 0 0 -19px;
    font-size: 16px;
    color: white;
  }
`;

const ContainerDiv_Over767 = styled.div`
  display: flex;
  padding: 0!important;
  width: 100%;
  max-width: 600px;

  .input-group-addon {
    height: 30px;
    padding: 0;
    margin-left: -1px;
    background: white;
    border: 1px solid gray!important;
    border-left: 0!important;

    img {
      width: 25px!important;
      height: 20px!important;
    }
  }

`;

const SearchInput = styled(Input)`
  height: 35px;
  font-size: 16px!important;
  padding: 6px 12px 6px 12px!important;
  border: 1px solid gray!important;
  // border-right: 0!important;
  border-radius: 0!important;

  :focus {
    box-shadow: none!important;
    outline: none!important;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ShopFilterSearchTextbox.js